import Reactportal from "../../Components/Reactportal/Reactportal";
import { RiErrorWarningFill } from "react-icons/ri";
import PortalFooter from "../Reactportal/PortalFooter";
export const Confirm = ({
  submitType = "Confirm Delete",
  submit,
  settoggle,
  toggle,
  loadingState,
  TypeOfPortal = "Confirm",
  message = "Are You Sure You Want to Delete this Record?",
}) => {
  return (
    <Reactportal
      Form_Key={"ConformPortal" + TypeOfPortal}
      open={toggle}
      onClose={() => toggle()}
      TypeOfPortal={TypeOfPortal}
    >
      <div className="warning">
        <RiErrorWarningFill className="warningIcon" />
        <p className="warningMsg">{message}</p>
      </div>

      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={() => {
          submit();
        }}
        submitType={submitType}
        handleformclose={() => {
          settoggle();
        }}
        loadingState={loadingState}
      />
    </Reactportal>
  );
};
